module.exports = __webpack_public_path__ + "img/magin-comment-icon.f5adca74.svg";